<template>
  <div class="alert alert-info fade show" role="alert">
    <a :href="link" target="_blank" rel="noopener noreferrer">{{text}}</a>
  </div>
</template>

<script>
export default {
    name:'AlertLink',
    props:{
        link: String,
        text: String
    }
};
</script>

<style>
</style>